import { FormField, RadioGroup } from '@wix/design-system';
import React, { useContext, useState } from 'react';
import { RicosContext } from 'ricos-context';
import { type HTMLData } from 'ricos-schema';
import { LinkInput } from 'wix-rich-content-ui-components';

import {
  EDIT_PANEL_RADIO_GROUP,
  EDIT_PANEL_RADIO_HTML,
  EDIT_PANEL_RADIO_URL,
  EDIT_PANEL_URL_INPUT,
} from '../../dataHooks';
import { HtmlInputArea } from './HtmlInputArea';

export type HtmlSourceInputProps = {
  componentData: HTMLData;
  updateComponentData: (data: HTMLData) => void;
  inputRef?: React.MutableRefObject<HTMLInputElement | null>;
};

const INPUT_HTML = 'html';
const INPUT_URL = 'url';
type InputType = typeof INPUT_HTML | typeof INPUT_URL;

export const HtmlSourceInput: React.FC<HtmlSourceInputProps> = ({
  componentData,
  updateComponentData,
  inputRef,
}) => {
  const { t } = useContext(RicosContext);
  const [inputType, setInputType] = useState<InputType>(componentData.url ? INPUT_URL : INPUT_HTML);

  return (
    <>
      <RadioGroup
        display="vertical"
        value={inputType}
        onChange={(value: InputType) => setInputType(value)}
        dataHook={EDIT_PANEL_RADIO_GROUP}
        size="small"
      >
        <RadioGroup.Radio value={INPUT_HTML} dataHook={EDIT_PANEL_RADIO_HTML}>
          {t('HtmlEditPanel_Code')}
        </RadioGroup.Radio>
        <RadioGroup.Radio value={INPUT_URL} dataHook={EDIT_PANEL_RADIO_URL}>
          {t('HtmlEditPanel_Source')}
        </RadioGroup.Radio>
      </RadioGroup>
      {inputType === INPUT_HTML ? (
        <HtmlInputArea
          placeholder={t('HtmlEditPanel_HtmlInput_Placeholder')}
          componentData={componentData}
          onChange={updateComponentData}
        />
      ) : (
        <LinkInput
          value={componentData.url ?? ''}
          placeholder={t('HtmlEditPanel_UrlInput_Placeholder')}
          dataHook={EDIT_PANEL_URL_INPUT}
          inputRef={inputRef}
          onChange={url => {
            updateComponentData({ ...componentData, url, html: undefined });
          }}
        />
      )}
    </>
  );
};
